import React, { useState, useEffect } from "react";
const CardStatBranchContent = ({ id, top, last }) => {
    useEffect(() => {
        return () => {};
    }, [top, last]);

    return (
        <div className="card mb-1 h-100">
            <div className="card-body text-dark">
                <div className="row mt-2">
                    <div className="col">
                        <span className="text-danger mr-1">최고 사용량:</span>
                        {top ? top.branchName : "-"}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <span className="text-primary mr-1">최저 사용량:</span>
                        {last ? last.branchName : "-"}
                    </div>
                </div>
            </div>
        </div>
    );
};
const CardStatContent = ({ id, title, total = 0, average, titleTotal = "전체 : ", titleAverage = "평균", titleBgClass = "" }) => {
    useEffect(() => {
        return () => {};
    }, [title, total, average]);

    return (
        <div className={`card mb-1 h-100`} style={{}}>
            <div className={`card-header stat-content ${titleBgClass}`}>{title}</div>
            <div className="card-body text-dark">
                <div className="row">
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                        {titleTotal} {total.toLocaleString()}
                    </div>
                    {average && (
                        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                            {titleAverage}: {average.toLocaleString()}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
const CardStatActivity = ({ id, title, total = 0, totalSum = 0, titleTotal = "순 실행 수", titleTotalSum = "누적 실행 수", titleBgClass = "" }) => {
    useEffect(() => {
        return () => {};
    }, [title, total, totalSum]);

    return (
        <div className={`card mb-1`} style={{}}>
            <div className={`card-header stat-content ${titleBgClass}`}>{title}</div>
            <div className="card-body text-dark">
                <div className="row">
                    <div className="col">
                        <div className="mb-2">
                            {titleTotal}: {total ? total.toLocaleString() : 0}
                        </div>
                        <div>
                            {titleTotalSum}: {totalSum ? totalSum.toLocaleString() : 0}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CardStatPie = ({ id, title, total = 0, average, titleTotal = "전체", titleAverage = "평균", titleBgClass = "" }) => {
    useEffect(() => {
        return () => {};
    }, [title, total, average]);

    return (
        <div className={`card mb-1 h-100`} style={{}}>
            <div className={`card-header stat-content ${titleBgClass}`}>{title}</div>
            <div className="card-body text-dark">
                <div className="row"></div>
            </div>
        </div>
    );
};

export { CardStatContent as default, CardStatBranchContent, CardStatActivity, CardStatPie };
